/**
 * Watermark overlay — fixed, full-viewport, non-interactive forensic trace.
 *
 * Pure presentational. Renders the supplied `text` rotated and low-alpha
 * via the `.watermark` / `.watermark-text` classes (defined in index.css).
 * No identity, no asset/image mode, no date logic.
 */

export interface WatermarkOverlayProps {
  text: string;
}

export function WatermarkOverlay({ text }: WatermarkOverlayProps) {
  return (
    <div className="watermark" aria-hidden="true">
      <div className="watermark-text">{text}</div>
    </div>
  );
}
